<h6 class="visually-hidden">
	<label [for]="selectElementId">{{ label }}</label>
</h6>
<div class="select-wrapper">
	<select [id]="selectElementId" class="border border-secondary" (change)="onSelect($event)">
		@for (option of options; track $index) {
			<option [value]="option.primaryValue" [attr.secondaryValue]="option.secondaryValue">
				{{ option.label }}
			</option>
		}
	</select>
</div>
